import Meta from 'src/components/meta/Meta';

const UpdateDetailsMeta = () => <Meta
  title={`Update Details | BrickX`}
  description="BrickX is the smart affordable way to build your home deposit or grow your wealth. Start investing in property for only a few hundred dollars."
  keywords="Property Investment"
/>;

export default UpdateDetailsMeta;
